import { useTranslation } from 'react-i18next';
import { DialogPanel } from './DialogPanel.jsx';

export function DialogConfigurePanel({ id, children, open, title, definitionUid }) {
    const { t } = useTranslation();
    const label = t('jobs:dialogs.definition.title', {
        context: definitionUid ? 'edit' : 'create'
    });

    return (
        <DialogPanel id={id} label={title ?? label} open={open}>
            {children}
        </DialogPanel>
    );
}
